import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
  List,
  IconButton,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import ReportsListItem from './ReportsListItem';
import InfiniteScroll from 'components/InfiniteScroll/InfiniteScroll';
import axios from 'api/axios';
import CloseIcon from '@material-ui/icons/Close';
import { useMainStore } from 'useStores/useMainStore';
import { useDriversList } from 'useStores/useTenderingStore';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 0,
    padding: 0,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const ReportsListModal = ({ onClose, open, id }) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const height = 600;
  const reportsPage = useDriversList((state) => state.reportOfFreightOrderPage);
  const limit = useMainStore((state) => state.limit);

  const reportOfFreightOrder = useDriversList(
    (state) => state.reportOfFreightOrder
  );
  const setReportPage = useDriversList(
    (state) => state.setReportOfFreightOrderPage
  );
  const setReportsOfFreightOrder = useDriversList(
    (state) => state.setReportsOfFreightOrder
  );

  const fetchReports = async (newSearch = false) => {
    setLoading(true);
    try {
      let offset = limit * reportsPage;
      const { data } = await axios.get(
        `/api/v1/admin/freight/order/${id}/resultOfDriversCalls?offset=${offset}&limit=${limit}`
      );
      if (newSearch) {
        setReportsOfFreightOrder(data);
        setReportPage(data?.resultOfDriversCalls?.page);
      } else {
        setReportsOfFreightOrder({
          ...data,
          resultOfDriversCalls: {
            ...data.resultOfDriversCalls,
            docs: [
              ...reportOfFreightOrder.resultOfDriversCalls?.docs,
              ...data?.resultOfDriversCalls?.docs,
            ],
          },
        });
      }
      setReportPage(data?.resultOfDriversCalls?.page);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReports(true);
  }, []);

  return (
    <Dialog fullWidth onClose={onClose} open={open}>
      <div>
        <DialogTitle>
          <div className="d-flex justify-content-between align-items-between">
            <span>لیست گزارشات</span>
            <IconButton aria-label="close" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>

        {
          <DialogContent className="text-center p-0 postition-relative">
            {reportOfFreightOrder?.resultOfDriversCalls?.docs.length === 0 ? (
              <>
                <DialogContentText>گزارشی وجود ندارد.</DialogContentText>
                <Button
                  fullWidth
                  className="position-sticky"
                  onClick={onClose}
                  color="secondary"
                  variant={'contained'}
                >
                  بستن
                </Button>
              </>
            ) : (
              <div style={{ height: '300px' }}>
                <List className={classes.root}>
                  <InfiniteScroll
                    hasMore={
                      reportOfFreightOrder?.resultOfDriversCalls?.hasNextPage
                    }
                    fetchMore={fetchReports}
                    loading={loading}
                    height={height}
                  >
                    {reportOfFreightOrder?.resultOfDriversCalls?.docs?.map(
                      (item, i) => (
                        <ReportsListItem
                          key={i}
                          report={item}
                          driver={item.driver}
                          id={id}
                        />
                      )
                    )}
                  </InfiniteScroll>
                </List>
                <Button
                  fullWidth
                  className="position-absolute"
                  style={{ bottom: 0, right: 0 }}
                  onClick={onClose}
                  color="secondary"
                  variant={'contained'}
                >
                  بستن
                </Button>
              </div>
            )}
          </DialogContent>
        }
      </div>
    </Dialog>
  );
};

export default ReportsListModal;
